import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Segment,
  Tab,
  TabPane,
  Header,
  Grid,
  GridColumn,
  Table,
  Dropdown,
  Confirm,
  Icon,
  Popup,
} from "semantic-ui-react";
import { Pie, Column,DualAxes } from "@ant-design/plots";
import { Link, useLocation } from "react-router-dom";
import { Permission, /* Form, Productionform, Socialform */ } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useWindowWidth } from "../../../../hooks/useWindowWidth";
//import "./Dashboard.scss";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { CollapsibleSection, LoadingSpinner } from "../../../Shared";
import SocialSummary from "./SocialSummary";
import TableGraf from "./TableGraf";
import {
  socialKPIsCodes,
  socialFormulasIndicators,
  determineSocialUnits,
  socialCodes,
} from "../../../../utils/dataAndFormulas/socialForms";

import {
  convertUnits,
  formatValue,
} from "../../../../utils/dataAndFormulas/convert";

const permissionController = new Permission();
// const socialController = new Socialform();
// const formController = new Form();
// const productionController = new Productionform();

export function SocialKPIsDashBoard(props) {
  const { site, sharedProductionForms, sharedWorkersByPeriod } = props;
  const {
    user: { role },
    accessToken,
  } = useAuth();
  const { language, translations } = useLanguage();

  const t = (key) => translations[key] || key;

  const [permissionActive, setPermissionsActive] = useState([]);
  const [baseline, setbaseline] = useState("");
  const [valueBaseline, setValueBaseline] = useState({});
  const [indicatorsLineBase, setIndicatorsLineBase] = useState([]);
  const [data, setData] = useState([]);
  const [totales, setTotales] = useState({});
  const [conceptos, setConceptos] = useState([]);
  const [configFormData, setConfigFormData] = useState(null);

  const [loadingCount, setLoadingCount] = useState(0);
  const isLoading = loadingCount > 0;

    const [lastYears, setLastYears] = useState({}); // resultados calculados
    const [totalesByFilters, setTotalesByFilters] = useState({}); // resultados calculados
    const [totalesWorkersByFilters, setTotalesWorkersByFilters] = useState({}); // resultados de trabajadores por mes
    const [totalesProductionsByFilters, setTotalesProductionsByFilters] = useState({}); // resultados de producción por mes

  const startLoading = () => setLoadingCount((prev) => prev + 1);
  const stopLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));
  
    //declaración estado de filtros
    const [filters, setFilters] = useState({
      year: new Date().getFullYear(),
      //month: new Date().getMonth() + 1,
    });

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getPermissionsByRole(
            accessToken,
            role._id,
            true
          );
          setPermissionsActive(response);
        }
      } catch (error) {
        socialKPIsCodes.error(error);
        setPermissionsActive([]);
      } finally {
        stopLoading();
      }
    })();
  }, []);

useEffect(() => {
  if (!site) return;

  const fetchData = async () => {
    startLoading();
    setData([]);
    setbaseline("");
    try {
      // --- 1. Obtener años de línea base y últimos 5 años ---
      const prueba = await socialController.getSocialFormsByLineBaseYears(
        accessToken,
        site
      );

      setIndicatorsLineBase(prueba.socialForms.indicators);

      const yearsLineaBase = prueba.socialForms.years;
      const currentYear = new Date().getFullYear();
      const yearsLast5 = Array.from({ length: 5 }, (_, i) => String(currentYear - i));

      const yearsCombined = [...new Set([...yearsLineaBase, ...yearsLast5])];

      // --- 2. Obtener datos de socialForms ---
      const responseSocial = await socialController.getSocialFormsByLastYears(
        accessToken,
        site,
        yearsCombined
      );
      setData(responseSocial.socialForms);

      // --- 3. Obtener baseline ---
      const responseBaseline = await formController.getLastBaselineByFormBySite(
        accessToken,
        site,
        "production"
      );

      if (responseBaseline.code === 200) {
        setbaseline(responseBaseline.baseline);

        const result = await Promise.all(
          Object.entries(responseBaseline.baseline)
            .filter(([anio, valor]) => valor !== null)
            .map(async ([anio, valor]) => {
              const a = await getValueBaseLine(anio, valor);
              return { [anio]: a };
            })
        );

        const resultadoFinal = result.reduce((acc, obj) => ({ ...acc, ...obj }), {});
        setValueBaseline(resultadoFinal);
      }
    } catch (error) {
      console.error(error);
      setData([]);
    } finally {
      stopLoading();
    }
  };

  fetchData();
}, [site]);

  // Obtener configuración de campos activos del formulario
  useEffect(() => {
    (async () => {
      try {
        if (site) {
          const response = await formController.getFormsBySite(
            accessToken,
            site,
            "social",
            true
          );
          if (Array.isArray(response) && response.length > 0) {
            setConfigFormData(response[0]);
          } else {
            setConfigFormData(null);
          }
        }
      } catch (error) {
        console.error("Error al obtener configFormData:", error);
        setConfigFormData(null);
      }
    })();
  }, [site]);

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        // Usar datos compartidos desde DashBoard.js
        if (site && sharedWorkersByPeriod && sharedProductionForms) {
          setTotalesWorkersByFilters(sharedWorkersByPeriod);

          const totalesFinalProductions = await calcularProduccionPorMesPorAño(sharedProductionForms, baseline);
          setTotalesProductionsByFilters(totalesFinalProductions);
        }

        const previous_totals = await transformData1(data);
        await calculateDataFinal(previous_totals);
        // Calcular totalesByFilters para últimos 5 años
        if (data?.data && Array.isArray(data.data) && data.data.length > 0) {
          const groupedData = groupDataByYearAndMonth(data.data);
          setTotalesByFilters(groupedData);
        }
      } catch (error) {
        console.error(error);
      } finally {
        stopLoading();
      }
    })();
  }, [data, valueBaseline, configFormData, sharedProductionForms, sharedWorkersByPeriod]);

  const getValueBaseLine = async (year, type) => {
    try {
      const mode =
        type === "VPS" ? "standardized_production" : "standardized_billing";
      const response1 =
        await productionController.getTotalBaselineByYearAndSite(
          accessToken,
          site,
          year,
          mode
        );
      return response1.total;
    } catch (error) {
      return 1;
    }
  };

  // Función para agrupar datos por año y mes
  const groupDataByYearAndMonth = (dataArray) => {
    const grouped = {};

    dataArray.forEach((item) => {
      const year = String(item.year);
      const month = item.period; // period viene en formato "January", "February", etc.

      if (!grouped[year]) {
        grouped[year] = {};
      }

      if (!grouped[year][month]) {
        grouped[year][month] = { ...item };
      } else {
        // Combinar datos de registros duplicados del mismo mes
        Object.keys(item).forEach((key) => {
          if (item[key] !== undefined && item[key] !== null) {
            // Si el campo actual no existe o está vacío, usar el nuevo valor
            if (!grouped[year][month][key] || grouped[year][month][key] === null) {
              grouped[year][month][key] = item[key];
            }
          }
        });
      }
    });

    return grouped;
  };

  // Función que obtiene los campos fuente de un KPI basándose en socialFormulasIndicators
  const getKPISourceFields = useCallback((kpiName) => {
    const kpiSourceMap = {
      // KPIs calculados - agregaciones (siempre mostrar)
      'quantity_workers_kpis': null, // Agregación de todos los trabajadores
      'quantity_permanent_workers_kpis': null, // Agregación de trabajadores permanentes
      'quantity_temporary_workers_kpis': null, // Agregación de trabajadores temporales
      'quantity_workers_production_kpis': null, // Agregación de trabajadores de producción
      'quantity_workers_administrative_kpis': null, // Agregación de trabajadores administrativos
      'total_hours_worked_extra_and_normal_kpis': null, // Agregación de horas
      'average_female_workers_leadership_positions_kpis': null, // Calculado
      'average_male_workers_leadership_positions_kpis': null, // Calculado
      'average_female_total_kpis': null, // Calculado
      'average_male_total_kpis': null, // Calculado
      'quantity_workers_under_cct_kpis': ['workers_under_cct'], // Directo Soc16
      'percentage_workers_under_cct_kpis': null, // Calculado: Soc16 / KPIsoc1
      'total_accidents_kpis': null, // Agregación de accidentes

      // KPIs directos - mapeo 1:1 con campos
      'total_days_worked_kpis': ['days_worked'],
      'total_hours_worked_kpis': ['normal_hours_worked'],
      'total_fifty_percent_overtime_kpis': ['fifty_percent_overtime'],
      'total_one_hundred_percent_overtime_kpis': ['one_hundred_percent_overtime'],
      'total_work_accidents_with_sick_days_kpis': ['work_accidents_with_sick_days'],
      'total_accidents_first_aid_kpis': ['first_aid_without_sick_days'],
      'total_in_itine_accidents_kpis': ['in_itine_accidents'],
      'total_hours_training_social_issues_kpis': ['hours_training_social_issues'],
      'total_hours_training_hys_kpis': ['hours_training_hys'],
      'total_hours_environmental_awareness_training_kpis': ['hours_environmental_awareness_training'],
      'total_volunteer_hours_kpis': ['volunteer_hours'],
      'total_complaints_or_suggestions_received_kpis': ['complaints_or_suggestions_received'],
    };
    return kpiSourceMap[kpiName];
  }, []);

  // 🚀 Memoizar determinación de campos basándose en configFormData
  const determineFieldsKPIs = useMemo(() => {
    const fields = new Set();

    Object.keys(socialKPIsCodes).forEach((key) => {
      const sourceFields = getKPISourceFields(key);

      // Si no tiene campos fuente definidos (es calculado/agregado), agregarlo por defecto
      if (!sourceFields) {
        fields.add(key);
        return;
      }

      // Si hay configFormData, verificar si TODOS los campos fuente están activos
      if (configFormData?.fields && configFormData.fields.length > 0) {
        const allSourceFieldsActive = sourceFields.every(sourceFieldName => {
          const fieldConfig = configFormData.fields.find(f => f.name === sourceFieldName);
          return fieldConfig && fieldConfig.active !== false;
        });

        if (allSourceFieldsActive) {
          fields.add(key);
        }
      } else {
        // Si no hay configFormData, mostrar todos los campos (comportamiento por defecto)
        fields.add(key);
      }
    });

    return Array.from(fields);
  }, [configFormData, getKPISourceFields]);
  
    // Determinar los campos únicos de los formularios y si tienen código
    const determineFieldsCode = () => {
      const fields = new Set();
  
      Object.keys(socialCodes).forEach((key) => {
        fields.add(key);
      });
  
      return Array.from(fields);
    };
  

  const transformData1 = async (data) => {
    const totalsPerYear = {};
    const conceptsSet = [];
    const unitsCache = {};

    // Unidades configuradas en configFormData tienen prioridad máxima
    const configUnits = {};
    if (configFormData?.fields && configFormData.fields.length > 0) {
      configFormData.fields.forEach((field) => {
        if (field.name && field.unit) {
          configUnits[field.name] = field.unit;
        }
      });
    }

    const fields = determineFieldsCode();
    const processedMonths = {}; // Trackear meses ya procesados por concepto/año

    if (!data || !Array.isArray(data.data) || data.data.length === 0) {
      return {};
    }

    const uniqueYears = [...new Set(data.data.map((item) => String(item.year)))];

    await Promise.all(
      uniqueYears.map(async (año) => {
        try {
          const units = await socialController.getLastUnitFieldsByYear(
            accessToken,
            site,
            año,
            fields
          );
          if (units && units.fields) {
            unitsCache[año] = units;
          }
        } catch (error) {}
      })
    );

    const consumptionPromises = data.data.map(async (item) => {
      const year = String(item.year);
      const month = item.period; // Mes del registro
      const units = unitsCache[year];
      if (!units) return;

      fields.forEach((concept) => {
        if (item[concept]) {
          conceptsSet.push(concept);
          if (!totalsPerYear[concept]) totalsPerYear[concept] = {};
          if (!totalsPerYear[concept][year]) {
            totalsPerYear[concept][year] = {
              total: 0,
              count: 0,
              unit: configUnits[concept] || units.fields[concept] || item[concept]?.unit || "",
            };
          }

          // Crear key única para evitar duplicados
          const monthKey = `${concept}_${year}_${month}`;
          if (!processedMonths[monthKey]) {
            processedMonths[monthKey] = true;

            const value = item[concept].value
              ? convertUnits(
                  item[concept].value,
                  item[concept].unit,
                  totalsPerYear[concept][year].unit
                )
              : 0;

            totalsPerYear[concept][year].total += value;
            totalsPerYear[concept][year].count += 1;
          }
        }
      });
    });

    await Promise.all(consumptionPromises);

    Object.keys(totalsPerYear).forEach((concept) => {
      Object.keys(totalsPerYear[concept]).forEach((year) => {
        const { total, count } = totalsPerYear[concept][year];
        if (count > 0) {
          totalsPerYear[concept][year].average = total / count;
        }
      });
    });

    return totalsPerYear;
  };

  const calculateDataFinal = async (totales) => {
    const totalesFinal = { ...totales };
    const conceptsSet = [];

    if (totales !== undefined) {
      for (let item in totales) {
        if (totales.hasOwnProperty(item)) {
          for (let year in totales[item]) {
            const valueB = valueBaseline[year];
            if (totales[item].hasOwnProperty(year)) {
              const fields = determineFieldsKPIs; // 🚀 Usar directamente el array memoizado

              fields.forEach((concept) => {
                if (!totalesFinal[concept]) {
                  totalesFinal[concept] = {};
                  conceptsSet.push(concept);
                }

                if (!totalesFinal[concept][year]) {
                  totalesFinal[concept][year] = {};
                }

                totalesFinal[concept][year] = socialFormulasIndicators(
                  concept,
                  year,
                  totalesFinal,
                  valueB === 0 ? 1 : valueB
                );
              });
            }
          }
        }
      }
    }

    setConceptos(removeNulls(totalesFinal, conceptsSet));
    setTotales(totalesFinal);
  };


  // Función para obtener los valores de un año y mes específicos (period en texto)
    const getDataByYearAndMonth = async (data, year, month) => {
      const results = {};
      const fields = determineFieldsCode();
      const unitsCache = {};

      const configUnits = {};
      if (configFormData?.fields && configFormData.fields.length > 0) {
        configFormData.fields.forEach((field) => {
          if (field.name && field.unit) {
            configUnits[field.name] = field.unit;
          }
        });
      }

      if (!data || !data || Object.keys(data).length === 0) {
        return {};
      }
  
      // Diccionario de meses
      const monthMap = {
        January: "01",
        February: "02",
        March: "03",
        April: "04",
        May: "05",
        June: "06",
        July: "07",
        August: "08",
        September: "09",
        October: "10",
        November: "11",
        December: "12",
      };
  
      const yearStr = String(year);
      const monthStr =
        typeof month === "string"
          ? monthMap[month] || ""
          : String(month).padStart(2, "0");
  
      if (!monthStr) {
        console.warn("Mes inválido o no reconocido:", month);
        return {};
      }
  
      const yearData = data[yearStr];
      if (!Array.isArray(yearData)) {
        console.warn("No hay datos para el año:", yearStr);
        return {};
      }
  
      const filteredData = yearData.filter(
        (item) => monthMap[item.period] === monthStr
      );
  
      if (filteredData.length === 0) {
        console.warn(`No hay datos para ${month} ${yearStr}`);
        return {};
      }
  
      // Procesar resultados por campo
      filteredData.forEach((item) => {
        const units = unitsCache[yearStr];
  
        fields.forEach((concept) => {
          if (item[concept]) {
            if (!results[concept]) {
              results[concept] = {
                total: 0,
                unit: configUnits[concept] || units?.fields[concept] || item[concept]?.unit || "",
              };
            }
  
            results[concept].total += item[concept].value
              ? convertUnitsFinal(
                  item[concept].value,
                  item[concept].unit,
                  results[concept].unit,
                  concept
                )
              : 0;
          }
        });
      });
  
      // ==========================
      // 🔹 Calcular energía total (sin incluir costos)
      // ==========================
  
      // Lista de conceptos energéticos (sin costos)
      const socialConcepts = Object.keys(socialCodes).filter(
        (key) => !key.includes("cost")
      );
  
      let totalSocialMonth = 0;
      let socialUnit = "";
  
      socialConcepts.forEach((concept) => {
        if (results[concept] && typeof results[concept].total === "number") {
          totalSocialMonth += results[concept].total;
          socialUnit = results[concept].unit || socialUnit;
        }
      });
  
      results.total_social_month = {
        total: totalSocialMonth,
        unit: socialUnit || "MWh",
      };
  
  
          // ==========================
      // 🔹 Calcular renovables
      // ==========================
  
          // ==========================
      // 🔹 Calcular electrica
      // ==========================
      return results;
    };
  
    // ==========================
    // 🔹 Calcular ultimos 3 años
    // ==========================
  
    const getLastThreeYearsData = async (totalesByFilters) => {
      const currentYear = new Date().getFullYear();
      const lastThreeYears = [currentYear - 2, currentYear - 1, currentYear];
  
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
  
      const resultsByYear = {};
  
      for (const year of lastThreeYears) {
        resultsByYear[year] = {};
  
        for (const month of months) {
          const data = await getDataByYearAndMonth(totalesByFilters, year, month);
          resultsByYear[year][month] = data;
        }
      }
  
      return resultsByYear;
    };
    console.log("eee", totalesByFilters)
    const removeNulls = (data, concepts) => {
      console.log("🔍 Verificando KPIs con filas vacías en Social...");
      console.log("📊 Total de KPIs antes del filtrado:", concepts.length);
      const removedKPIs = [];

      // Iterar sobre las claves externas
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          // Verificar si todos los valores internos son 0
          const allZero = Object.values(data[key]).every(
            (value) =>
              value.total === 0 || value.total === undefined || isNaN(value.total)
          );

          // Si todos los valores son 0, eliminar la clave externa
          if (allZero) {
            console.log(`❌ KPI eliminado (fila vacía): ${key}`);
            removedKPIs.push(key);
            concepts = concepts.filter((item) => item !== key);
          }
        }
      }

      console.log("📊 Total de KPIs después del filtrado:", concepts.length);
      console.log("🗑️ KPIs eliminados por tener fila vacía:", removedKPIs);
      console.log("✅ KPIs visibles:", concepts);

      return concepts;
    };
  
  async function calcularProduccionPorMesPorAño(documentosPorAño, baselines) {
    const resultado = {};
    for (const [year, docs] of Object.entries(documentosPorAño)) {
      const baselineType = baselines[year];
      if (!baselineType) continue;
      const fieldName = baselineType === "VPS" ? "standardized_production" : "standardized_billing";
      resultado[year] = {};
      for (const doc of docs) {
        const mes = doc.period;
        if (!mes) continue;
        resultado[year][mes] = doc[fieldName]?.value || 0;
      }
    }
    return resultado;
  }

    if (isLoading) {
      return <LoadingSpinner />;
    }
  
    if (
      !data ||
      !data.years ||
      data.years.length === 0 ||
      !conceptos ||
      conceptos.length === 0
    ) {
      return (
        <div style={{ textAlign: "center", padding: "5em 0", color: "#777" }}>
          <div style={{ fontSize: "2em", marginBottom: "1em", color: "#ccc" }}>
            <Icon name="exclamation triangle" size="huge" color="gray" />
          </div>
          <div
            style={{ fontSize: "1.5em", fontWeight: "bold", marginBottom: "1em" }}
          >
            {t("no_data_available") || "No hay datos disponibles"}
          </div>
        </div>
      );
    } else {
      return (
        <div className="list-energy-forms">
          {/* Sección de Resumen */}
          <div className="social-summary-section">
            <SocialSummary
              filters={filters}
              site={site}
              baseline={baseline}
              valueBaseline={valueBaseline}
              socialController={Socialform}
              totales={totalesByFilters} // ✅ datos por año/mes
              totalesKPIs={totales} // ✅ KPIs calculados
              selectorSlot={<YearMonthSelector onChange={setFilters} />}
            />
          </div>
          <TableGraf
            filters={filters}
            totales={totales}
            baseline={baseline}
            valueBaseline={valueBaseline}
            site={site}
            t={t}
          />
          <CollapsibleSection title={t("production_comparison_last_3_years")} className="social-comparison-section">
            <SocialComparisonChart
              baseline={baseline}
              site={site}
              t={t}
            />
          </CollapsibleSection>
          <CollapsibleSection title={t("workers_comparison_last_3_years")} className="social-monthly-section">
            <SocialMonthlyChart resultsByYear={totalesByFilters} t={t} />
          </CollapsibleSection>
          <CollapsibleSection title={t("productivity_comparison_last_3_years")} className="social-productivity-section">
            <ProductivityChart
              baseline={baseline}
              site={site}
              resultsByYear={totalesByFilters}
              resultsWorkers={totalesWorkersByFilters}
              resultsProductions={totalesProductionsByFilters}
              t={t}
            />
          </CollapsibleSection>
          {/* //<EnergyChart filters={filters} data={data} /> */}
          {/*} <EnergyIntensityChart  totales={totales} />*/}

          <CollapsibleSection
            className="social-table-section"
            header={
              <div className="social-table-col-header">
                <span className="col-code">{t("code")}</span>
                <span className="col-indicators">{t("indicators")}</span>
                <span className="col-years">
                  {(data.years
                    ? [...data.years].sort((a, b) => b - a).slice(0, 5)
                    : []
                  ).map((y) => (
                    <span key={y} className="col-year">{y}</span>
                  ))}
                </span>
                <span className="col-lb">{t("LB")}</span>
                <span className="col-units">{t("units")}</span>
              </div>
            }
            defaultOpen={true}
          >
            <TableYears
              filters={filters}
              data={data}
              accessToken={accessToken}
              t={t}
              conceptos={conceptos}
              totales={totales}
              language={language}
              indicatorsLineBase={indicatorsLineBase}
              valueBaseline={valueBaseline}
            />
          </CollapsibleSection>

          {/* Sección de Valores Intermedios */}
          <IntermediateValuesDisplay
            resultsByYear={totalesByFilters}
            resultsWorkers={totalesWorkersByFilters}
            resultsProductions={totalesProductionsByFilters}
            t={t}
          />
        </div>
      );
    }
  }
  
  function TableYears(props) {
    const {
      data,
      conceptos,
      totales,
      t,
      language,
      valueBaseline,
      indicatorsLineBase,
      filters,
    } = props;
  
    const { year, month } = filters || {};
    const [years, setYears] = useState([]);
    const [months, setMoths] = useState([]);
    const [listConceptos, setListConceptos] = useState([]);
  
    useEffect(() => {
      console.log("📊 TableGraf filtrando con:", { year, month });
    }, [year, month]);
  
    useEffect(() => {
      (async () => {
        try {
          setYears(data.years ? data.years.sort((a, b) => b - a) : []);
        } catch (error) {
          console.error(error);
        }
      })();
    }, [data]);
  
    useEffect(() => {
      (async () => {
        try {
          setListConceptos(conceptos);
        } catch (error) {
          console.error(error);
        }
      })();
    }, [conceptos]);

    // Función para obtener el icono de aumento o disminución
    const getComparativeIcon = (currentYear, previousYear) => {
      if (previousYear !== null) {
        if (currentYear > previousYear) {
          return <Icon disabled name="angle up" color="green" />; // Aumento
        } else if (currentYear < previousYear) {
          return <Icon disabled name="angle down" color="red" />; // Disminución
        } else if (currentYear === previousYear) {
          return <span style={{ color: "blue", fontWeight: "bold" }}>=</span>;
        }
      }
      return null; // Sin cambio
    };
  
    // Función para obtener el icono de aumento o disminución
    const getIndicators = (item) => {
      let result = indicatorsLineBase.find((value) => value.name === item);
      if (result) {
        return result?.yearBaseline || 0;
      }
      return 0; // Sin cambio
    };
  
    // Obtener la unidad del primer año disponible para un concepto
    const getUnitForItem = (item) => {
      const firstYear = years.find((y) => totales[item]?.[y]?.unit);
      return firstYear ? totales[item][firstYear].unit : "";
    };

    // Determina los decimales necesarios para un valor individual
    const getNeededDecimals = (value) => {
      if (typeof value !== "number" || isNaN(value) || value === 0) return 2;
      const abs = Math.abs(value);
      if (abs >= 0.005) return 2;
      if (abs >= 0.0005) return 3;
      if (abs >= 0.00005) return 4;
      return -1;
    };

    // Determina la cantidad de decimales consistente para toda una fila
    const getRowDecimalPlaces = (values) => {
      let maxDecimals = 2;
      for (const v of values) {
        if (typeof v !== "number" || isNaN(v) || v === 0) continue;
        const needed = getNeededDecimals(v);
        if (needed === -1) continue;
        if (needed > maxDecimals) maxDecimals = needed;
      }
      return Math.min(maxDecimals, 4);
    };

    // Formatea un valor con la cantidad de decimales determinada para la fila
    const formatWithDecimals = (value, decimals) => {
      if (typeof value !== "number" || isNaN(value)) return "-";
      if (value === 0) return "-";
      if (Math.abs(value) < 0.00005) return decimals === 0 ? "0" : (0).toFixed(decimals);
      if (decimals === 0) return Math.round(value).toString();
      return value.toFixed(decimals);
    };

    // Renderiza una píldora de comparativa rojo/verde
    const renderPill = (value, prevValue, decimals, isCount) => {
      const numValue = value != null ? Number(value) : null;
      const numPrev = prevValue != null ? Number(prevValue) : null;

      if (numValue == null || numValue === 0) {
        return <span className="gei-value-pill pill-empty" />;
      }

      let pillClass;
      if (numPrev == null || numPrev === 0) {
        pillClass = "pill-neutral";
      } else if (numValue > numPrev) {
        pillClass = "pill-up";
      } else if (numValue < numPrev) {
        pillClass = "pill-down";
      } else {
        pillClass = "pill-neutral";
      }

      const displayText = isCount
        ? Math.round(numValue).toString()
        : formatWithDecimals(numValue, decimals);

      return (
        <span className={`gei-value-pill ${pillClass}`}>
          {formatValue(displayText, language)}
        </span>
      );
    };

    return (
      <>
        <Table celled structured size="small" className="gei-kpi-table">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell rowSpan="2" textAlign="center">
                {t("code")}
              </Table.HeaderCell>
              <Table.HeaderCell rowSpan="2" textAlign="center">
                {t("indicators")}
              </Table.HeaderCell>
              {years.map((year, index) => (
                <Table.HeaderCell rowSpan="2" textAlign="center" key={index}>
                  {year}
                </Table.HeaderCell>
              ))}
              <Table.HeaderCell rowSpan="2" textAlign="center">
                {t("LB")}
              </Table.HeaderCell>
              <Table.HeaderCell
                rowSpan="2"
                textAlign="center"
                style={{ width: "200px" }}
              >
                {t("units")}
              </Table.HeaderCell>
              {/* <Table.HeaderCell rowSpan="2" textAlign="center">
                {t("MWh equivalentes")}
              </Table.HeaderCell> */}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {conceptos.map((item, index) => {
              // Recopilar todos los valores de la fila para determinar decimales consistentes
              const rowValues = years
                .map((y) => totales[item]?.[y]?.total || 0)
                .filter((v) => typeof v === "number" && !isNaN(v));
              const lbValue = totales[item]?.[getIndicators(item)]?.total || 0;
              if (typeof lbValue === "number" && !isNaN(lbValue)) rowValues.push(lbValue);
              const rowDecimals = getRowDecimalPlaces(rowValues);
              const unit = getUnitForItem(item);
              const isCount = unit === "Unid." || unit === "uni";

              return (
              <React.Fragment key={index}>
                <Table.Row>
                  <Table.Cell>{socialKPIsCodes[item]}</Table.Cell>
                  <Table.Cell>{t(item)}</Table.Cell>
                  {years.map((year, i) => {
                    if (totales[item]) {
                      const currentValue = totales[item][year]?.total || 0;
                      const previousValue = totales[item][year - 1]?.total || 0;
                      const pill = renderPill(currentValue, previousValue, rowDecimals, isCount);
                      return (
                        <Table.Cell key={i} textAlign="center">
                          {pill}
                        </Table.Cell>
                      );
                    }
                    return <Table.Cell key={i}>{""}</Table.Cell>;
                  })}
                  <Table.Cell>
                    {(() => {
                      const lbVal = totales[item][getIndicators(item)]?.total || 0;
                      const lbFormatted = formatWithDecimals(lbVal, rowDecimals);
                      const lbDisplay = isCount && lbFormatted !== "-"
                        ? Math.round(lbVal).toString()
                        : lbFormatted;
                      if (isCount && lbFormatted !== "-") {
                        return (
                          <Popup
                            content={formatValue(lbFormatted, language)}
                            trigger={<span style={{ cursor: "default" }}>{formatValue(lbDisplay, language)}</span>}
                            size="small"
                            position="top center"
                          />
                        );
                      }
                      return formatValue(lbDisplay, language);
                    })()}
                  </Table.Cell>
                  <Table.Cell>
                    {unit}
                  </Table.Cell>

                  {/* <Table.Cell>
                    {convertUnitsFinal(
                      totales[item][getIndicators(item)]?.total || 0,
                      totales[item][getIndicators(item)]?.unit,
                      "MWh",
                      item
                    ) || 0}
                  </Table.Cell> */}
                </Table.Row>
              </React.Fragment>
              );
            })}
          </Table.Body>
        </Table>
      </>
    );
  }
  
  export const YearMonthSelector = ({ onChange }) => {
    const currentYear = new Date().getFullYear();

    const years = [
      { key: currentYear, text: currentYear, value: currentYear },
      { key: currentYear - 1, text: currentYear - 1, value: currentYear - 1 },
      { key: currentYear - 2, text: currentYear - 2, value: currentYear - 2 },
      { key: currentYear - 3, text: currentYear - 3, value: currentYear - 3 },
       { key: currentYear - 4, text: currentYear - 4, value: currentYear - 4 },
    ];

    // const months = [
    //   { key: 1, text: "Enero", value: 1 },
    //   { key: 2, text: "Febrero", value: 2 },
    //   { key: 3, text: "Marzo", value: 3 },
    //   { key: 4, text: "Abril", value: 4 },
    //   { key: 5, text: "Mayo", value: 5 },
    //   { key: 6, text: "Junio", value: 6 },
    //   { key: 7, text: "Julio", value: 7 },
    //   { key: 8, text: "Agosto", value: 8 },
    //   { key: 9, text: "Septiembre", value: 9 },
    //   { key: 10, text: "Octubre", value: 10 },
    //   { key: 11, text: "Noviembre", value: 11 },
    //   { key: 12, text: "Diciembre", value: 12 },
    // ];

    const [selectedYear, setSelectedYear] = useState(currentYear);
    // const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // 1-12

    const handleYearChange = (e, { value }) => {
      setSelectedYear(value);
      onChange({ year: value }); // onChange({ year: value, month: selectedMonth });
    };

    // const handleMonthChange = (e, { value }) => {
    //   setSelectedMonth(value);
    //   onChange({ year: selectedYear, month: value });
    // };

    return (
      <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
        <Dropdown
          placeholder="Año"
          selection
          options={years}
          value={selectedYear}
          onChange={handleYearChange}
          className="year-filter-dropdown"
        />
        {/* <Dropdown
          placeholder="Mes"
          selection
          options={months}
          value={selectedMonth}
          onChange={handleMonthChange}
        /> */}
      </div>
    );
  };

function SocialComparisonChart({ baseline, site, t }) {
  const windowWidth = useWindowWidth();
  const { accessToken } = useAuth();

  // Estado para los datos mensuales de producción
  const [monthlyProductionData, setMonthlyProductionData] = useState({});

  // Obtener los datos mensuales de producción
  useEffect(() => {
    const fetchMonthlyProductionData = async () => {
      if (!baseline || !site) return;

      const currentYear = new Date().getFullYear();
      const lastThreeYears = Array.from({ length: 3 }, (_, i) =>
        String(currentYear - i),
      );

      try {
        const response =
          await productionController.getProductionFormsBySiteAndYears(
            accessToken,
            site,
            lastThreeYears,
          );

        console.log("🔍 Response completo:", response);

        // 🔥 1️⃣ Extraer TODOS los arrays del response
        const collectAllArrays = (obj, arrays = []) => {
          if (Array.isArray(obj)) {
            arrays.push(...obj);
            return arrays;
          }

          if (typeof obj === "object" && obj !== null) {
            for (let key in obj) {
              collectAllArrays(obj[key], arrays);
            }
          }

          return arrays;
        };

        const dataArray = collectAllArrays(response);

        console.log("📊 Años únicos detectados:", [
          ...new Set(dataArray.map((i) => i.year)),
        ]);

        // 🔥 2️⃣ Organizar por año y mes
        const organizedData = {};

        dataArray.forEach((item) => {
          const year = String(item.year);
          const month = item.period;

          if (!organizedData[year]) {
            organizedData[year] = {};
          }

          const baselineType = baseline?.[year] || "VPS";
          const fieldName =
            baselineType === "VPS"
              ? "standardized_production"
              : "standardized_billing";

          organizedData[year][month] = {
            value: item[fieldName]?.value || 0,
            type: baselineType,
          };
        });

        console.log("✅ Años en organizedData:", Object.keys(organizedData));

        setMonthlyProductionData(organizedData);
      } catch (error) {
        console.error(
          "❌ Error obteniendo datos de producción mensuales:",
          error,
        );
        setMonthlyProductionData({});
      }
    };

    fetchMonthlyProductionData();
  }, [baseline, site, accessToken]);

  const responsiveConfig = useMemo(() => {
    const isMobile = windowWidth <= 768;
    const isSmallMobile = windowWidth <= 480;
    const isTablet = windowWidth > 768 && windowWidth <= 992;

    return {
      isMobile,
      isSmallMobile,
      isTablet,
      fontSize: {
        large: isSmallMobile ? 12 : isMobile ? 14 : 16,
        medium: isSmallMobile ? 10 : isMobile ? 11 : 12,
        small: isSmallMobile ? 9 : isMobile ? 10 : 11,
      },
      chartHeight: isSmallMobile ? 250 : isMobile ? 280 : 300,
    };
  }, [windowWidth]);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Obtener los últimos 3 años
  const currentYear = new Date().getFullYear();
  const lastThreeYears = Array.from({ length: 3 }, (_, i) =>
    String(currentYear - i),
  );

  // ✅ Calcular los datos solo cuando cambien monthlyProductionData
  const { barData, lineData } = useMemo(() => {
    const bar = [];
    const line = [];

    lastThreeYears.forEach((year) => {
      const yearData = monthlyProductionData[year];

      let total = 0;
      let monthsWithData = 0;

      if (yearData) {
        // Primero recorremos los meses para calcular promedio real
        months.forEach((month) => {
          const monthData = yearData[month];
          const value = monthData?.value || 0;

          if (monthData && monthData.value > 0) {
            total += monthData.value;
            monthsWithData++;
          }
        });
      }

      const average = monthsWithData > 0 ? total / monthsWithData : 0;

      // Ahora generamos datos mes por mes
      months.forEach((month) => {
        const monthData = yearData?.[month];
        const value = monthData?.value || 0;
        const type = monthData?.type || baseline?.[year] || "VPS";

        // Barras → valor real mensual
        // Barras
        bar.push({
          year: String(year),
          month: t(month),
          value,
          type,
          isAverage: false,
        });

        // Línea (promedio)
        line.push({
          year: String(year),
          month: t(month),
          value: average,
          type,
          isAverage: true,
        });
      });
    });

    return { barData: bar, lineData: line };
  }, [monthlyProductionData, baseline, lastThreeYears, months]);

  // const config = {
  //   xField: "month",
  //   legend: {
  //     position: "top",
  //     itemName: {
  //       style: {
  //         fontSize: responsiveConfig.fontSize.medium,
  //       },
  //     },
  //   },
  //   autoFit: true,
  //   children: [
  //     {
  //       data: barData,
  //       type: "interval",
  //       yField: "value",
  //       colorField: "year",
  //       seriesField: "year",
  //       group: true,
  //       interaction: { elementHighlight: { background: true } },
  //     },
  //     {
  //       data: lineData,
  //       type: "line",
  //       yField: "value",
  //       colorField: "year",
  //       smooth: true,
        
  //       style: { lineWidth: 2, lineDash: [4, 4] },
  //       axis: { y: { position: "right" } },
  //     },
  //   ],
  //   tooltip: {
  //     shared: true,
  //     title: (d) => d.month,
  //     items: [
  //       (datum) => ({
  //         name: datum.isAverage
  //           ? `Promedio ${datum.year} (${datum.type || "VPS"})`
  //           : `Año ${datum.year} (${datum.type || "VPS"})`,
  //         value: datum.value
  //           ? datum.value.toLocaleString("es-ES", {
  //               minimumFractionDigits: 2,
  //               maximumFractionDigits: 2,
  //             })
  //           : "0",
  //       }),
  //     ],
  //   },

  //   height: responsiveConfig.chartHeight,
  //   xAxis: {
  //     title: {
  //       style: {
  //         fontSize: responsiveConfig.fontSize.medium,
  //       },
  //     },
  //     label: {
  //       style: {
  //         fontSize: responsiveConfig.fontSize.small,
  //       },
  //       autoRotate: responsiveConfig.isMobile ? true : false,
  //       autoHide: responsiveConfig.isMobile,
  //     },
  //   },
  //   yAxis: {
  //     title: {
  //       style: {
  //         fontSize: responsiveConfig.fontSize.medium,
  //       },
  //     },
  //     label: {
  //       style: {
  //         fontSize: responsiveConfig.fontSize.small,
  //       },
  //       formatter: (v) => {
  //         if (responsiveConfig.isMobile && v >= 1000) {
  //           return `${(v / 1000).toFixed(1)}K`;
  //         }
  //         return v;
  //       },
  //     },
  //   },
  // };
  const CustomLegend = () => (
    <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px", marginBottom: "20px", paddingLeft: "5px", flexWrap: "wrap" }}>
      {lastThreeYears.map((year) => {
        const isActive = activeYears.includes(year);
        return (
          <div
            key={year}
            onClick={() => toggleYear(year)}
            style={{
              backgroundColor: isActive ? yearColorMap[year] : "#f3f4f6",
              color: isActive ? "white" : "#9ca3af",
              padding: "4px 20px",
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              border: isActive ? `1px solid ${yearColorMap[year]}` : "1px solid #d1d5db",
              boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "100px",
            }}
          >
            {year}
          </div>
        );
      })}
    </div>
  );

  const [activeYears, setActiveYears] = useState(lastThreeYears);

  const toggleYear = (year) => {
    if (activeYears.includes(year)) {
      setActiveYears(activeYears.filter(y => y !== year));
    } else {
      setActiveYears([...activeYears, year]);
    }
  };

  const filteredBarData = useMemo(() =>
    barData.filter(d => activeYears.includes(String(d.year))),
  [barData, activeYears]);

  const filteredLineData = useMemo(() =>
    lineData.filter(d => activeYears.includes(String(d.year))),
  [lineData, activeYears]);

  const getCssVar = (name) =>
    getComputedStyle(document.documentElement).getPropertyValue(name).trim();

  const chartColors = {
    oldest: getCssVar("--chart-year-oldest"),
    prev: getCssVar("--chart-year-prev"),
    last: getCssVar("--chart-year-last"),
  };

  const yearColorMap = useMemo(() => {
    const sorted = [...lastThreeYears].map(Number).sort((a, b) => a - b);
    return {
      [sorted[0]]: chartColors.oldest || "#cbd5e1",
      [sorted[1]]: chartColors.prev || "#94a3b8",
      [sorted[2]]: chartColors.last || "#1e293b",
    };
  }, [lastThreeYears]);

  const config = {
    xField: "month",
    legend: false,
    scale: {
      color: {
        domain: Object.keys(yearColorMap),
        range: Object.values(yearColorMap),
      },
      y: { sync: true, nice: true, domainMin: 0 },
    },
    axis: {
      x: { title: false, labelAutoHide: false, labelAutoRotate: false },
      y: { title: false, grid: true, labelFormatter: (v) => Math.round(v).toLocaleString("es-AR") },
    },
    tooltip: {
      shared: true,
      title: (d) => d.month,
      items: [
        (datum) => ({
          name: datum.isAverage
            ? `Promedio ${datum.year} (${datum.type || "VPS"})`
            : `Año ${datum.year} (${datum.type || "VPS"})`,
          value: datum.value
            ? datum.value.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : "0",
        }),
      ],
    },
    children: [
      {
        data: filteredBarData,
        type: "interval",
        yField: "value",
        colorField: "year",
        group: true,
        style: { maxWidth: 80 },
        scale: { color: ({ year }) => yearColorMap[year] },
      },
      {
        data: filteredLineData,
        type: "line",
        yField: "value",
        colorField: "year",
        axis: { y: false },
        style: { lineWidth: 2,
        lineDash: [4, 8]},
      },
    ],
  };

  return (
    <div style={{ marginTop: 20, marginBottom: 40 }}>
      {barData.length > 0 && <CustomLegend />}
      {barData.length ? (
        <div style={{ height: 350 }}>
          <DualAxes {...config} />
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 350, color: "#999" }}>
          No hay datos disponibles
        </div>
      )}
    </div>
  );
}

function SocialMonthlyChart({ resultsByYear, t }) {
  const windowWidth = useWindowWidth();

  // Función para calcular KPISoc1 (cantidad total de trabajadores) por mes
  const calculateWorkersPerMonth = (monthData) => {
    if (!monthData) return 0;

    // KPISoc1 = (Soc5 + Soc6 + Soc7) + (Soc8 + Soc9 + Soc10) + (Soc11 + Soc12 + Soc13) + (Soc14 + Soc15)
    // Trabajadores de producción
    const productionWorkers =
      (monthData.female_production_workers?.value || 0) +
      (monthData.male_production_workers?.value || 0) +
      (monthData.other_gender_production_workers?.value || 0);

    // Trabajadores administrativos
    const administrativeWorkers =
      (monthData.female_administrative_workers?.value || 0) +
      (monthData.male_administrative_workers?.value || 0) +
      (monthData.administrative_workers_other_genders?.value || 0);

    // Trabajadores temporales
    const temporaryWorkers =
      (monthData.female_temporary_workers?.value || 0) +
      (monthData.male_temporary_workers?.value || 0) +
      (monthData.temporary_workers_other_genders?.value || 0);

    // Trabajadores en posiciones de liderazgo
    const leadershipWorkers =
      (monthData.female_workers_leadership_positions?.value || 0) +
      (monthData.male_workers_leadership_positions?.value || 0);

    return (
      productionWorkers +
      administrativeWorkers +
      temporaryWorkers +
      leadershipWorkers
    );
  };

  const responsiveConfig = useMemo(() => {
    const isMobile = windowWidth <= 768;
    const isSmallMobile = windowWidth <= 480;
    const isTablet = windowWidth > 768 && windowWidth <= 992;

    return {
      isMobile,
      isSmallMobile,
      isTablet,
      fontSize: {
        large: isSmallMobile ? 12 : isMobile ? 14 : 16,
        medium: isSmallMobile ? 10 : isMobile ? 11 : 12,
        small: isSmallMobile ? 9 : isMobile ? 10 : 11,
      },
      chartHeight: isSmallMobile ? 250 : isMobile ? 280 : 300,
    };
  }, [windowWidth]);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Obtener los últimos 3 años
  const currentYear = new Date().getFullYear();
  const lastThreeYears = Array.from({ length: 3 }, (_, i) =>
    String(currentYear - i),
  );

  // ✅ Calcular los datos solo cuando cambien resultsByYear
// ✅ Calcular los datos solo cuando cambien resultsByYear
  const { barData, lineData } = useMemo(() => {
    const bar = [];
    const line = [];

    lastThreeYears.forEach((year) => {
      let total = 0;
      let count = 0;
      const yearBarData = [];

      months.forEach((month) => {
        const monthData = resultsByYear?.[year]?.[month];
        const workersCount = calculateWorkersPerMonth(monthData);

        // SOLO agregamos la barra si hay trabajadores (evita barras en 0)
        if (workersCount > 0) {
          yearBarData.push({
            year: String(year),
            month: t(month),
            value: workersCount,
            type: `Total ${year}`,
          });
          total += workersCount;
          count++;
        }
      });

      bar.push(...yearBarData);

      // Calculamos el promedio anual basado solo en meses con datos
      const avg = count ? total / count : 0;

      // Si el promedio es > 0, creamos la línea
      if (avg > 0) {
        months.forEach((month) => {
          // OPCIONAL: Si quieres que la línea solo aparezca en los meses que tienen barra:
          // const hasData = resultsByYear?.[year]?.[month];
          // if (hasData) { ... }
          
          line.push({
            year: String(year),
            month: t(month),
            value: avg,
            type: `Promedio ${year}`,
          });
        });
      }
    });

    return { barData: bar, lineData: line };
  }, [resultsByYear, lastThreeYears, months, t]);
  const CustomLegend = () => (
    <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px", marginBottom: "20px", paddingLeft: "5px", flexWrap: "wrap" }}>
      {lastThreeYears.map((year) => {
        const isActive = activeYears.includes(year);
        return (
          <div
            key={year}
            onClick={() => toggleYear(year)}
            style={{
              backgroundColor: isActive ? yearColorMap[year] : "#f3f4f6",
              color: isActive ? "white" : "#9ca3af",
              padding: "4px 20px",
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              border: isActive ? `1px solid ${yearColorMap[year]}` : "1px solid #d1d5db",
              boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "100px",
            }}
          >
            {year}
          </div>
        );
      })}
    </div>
  );

  const [activeYears, setActiveYears] = useState(lastThreeYears);

  const toggleYear = (year) => {
    if (activeYears.includes(year)) {
      setActiveYears(activeYears.filter(y => y !== year));
    } else {
      setActiveYears([...activeYears, year]);
    }
  };

  const filteredBarData = useMemo(() =>
    barData.filter(d => activeYears.includes(String(d.year))),
  [barData, activeYears]);

  const filteredLineData = useMemo(() =>
    lineData.filter(d => activeYears.includes(String(d.year))),
  [lineData, activeYears]);

  const getCssVar = (name) =>
    getComputedStyle(document.documentElement).getPropertyValue(name).trim();

  const chartColors = {
    oldest: getCssVar("--chart-year-oldest"),
    prev: getCssVar("--chart-year-prev"),
    last: getCssVar("--chart-year-last"),
  };

  const yearColorMap = useMemo(() => {
    const sorted = [...lastThreeYears].map(Number).sort((a, b) => a - b);
    return {
      [sorted[0]]: chartColors.oldest || "#cbd5e1",
      [sorted[1]]: chartColors.prev || "#94a3b8",
      [sorted[2]]: chartColors.last || "#1e293b",
    };
  }, [lastThreeYears]);

  const config = {
    xField: "month",
    legend: false,
    scale: {
      color: {
        domain: Object.keys(yearColorMap),
        range: Object.values(yearColorMap),
      },
    },
    tooltip: {
      items: [
        (item) => {
          const marker = item.type?.includes("Promedio") ? "- -" : "";
          return {
            name: `${marker} ${item.type}`,
            value: item.value.toFixed(2),
          };
        },
      ],
    },
    axis: {
      x: { title: false, labelAutoHide: false, labelAutoRotate: false },
      y: { title: false, grid: true },
    },
    children: [
      {
        data: filteredBarData,
        type: "interval",
        yField: "value",
        colorField: "year",
        seriesField: "year",
        group: true,
        style: { maxWidth: 80 },
        scale: { color: ({ year }) => yearColorMap[year] },
        interaction: { elementHighlight: { background: true } },
      },
      {
        data: filteredLineData,
        type: "line",
        yField: "value",
        colorField: "year",
        style: {lineWidth: 2,
        lineDash: [4, 8] },
        axis: { y: false },
      },
    ],
  };

  return (
    <div style={{ marginTop: 20, marginBottom: 40 }}>
      {barData.length > 0 && <CustomLegend />}
      {barData.length ? (
        <div style={{ height: 350 }}>
          <DualAxes {...config} />
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 350, color: "#999" }}>
          No hay datos disponibles
        </div>
      )}
    </div>
  );
}

  function ProductivityChart({ baseline, resultsWorkers, resultsProductions, t }) {

    const windowWidth = useWindowWidth();

    const responsiveConfig = useMemo(() => {
      const isMobile = windowWidth <= 768;
      const isSmallMobile = windowWidth <= 480;

      return {
        isMobile,
        isSmallMobile,
        fontSize: {
          large: isSmallMobile ? 12 : isMobile ? 14 : 16,
          medium: isSmallMobile ? 10 : isMobile ? 11 : 12,
          small: isSmallMobile ? 9 : isMobile ? 10 : 11,
        },
        chartHeight: isSmallMobile ? 250 : isMobile ? 280 : 300,
      };
    }, [windowWidth]);

    const months = useMemo(() => [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ], []);

    // Obtener los últimos 3 años
    const currentYear = new Date().getFullYear();
    const lastThreeYears = useMemo(
      () => Array.from({ length: 3 }, (_, i) => String(currentYear - i)),
      [currentYear]
    );

    // Productividad mensual = producción_mes / trabajadores_mes
  const { consumptionData, lineData } = useMemo(() => {
      const cData = [];
      const line = [];

      lastThreeYears.forEach((year) => {
        const productionType = baseline?.[year] || "VPS";
        let total = 0;
        let count = 0;

        months.forEach((month) => {
          const production = resultsProductions?.[year]?.[month] || 0;
          const workers = resultsWorkers?.[year]?.[month] || 0;

          // Calculamos la productividad
          const productivityValue = workers > 0 ? production / workers : 0;

          // SOLO agregamos al array si el valor es mayor a cero
          // Esto hará que la línea se detenga o tenga huecos en meses sin datos
          if (productivityValue > 0) {
            cData.push({
              year: String(year),
              month: t(month),
              value: Math.round(productivityValue),
              type: `${productionType} / ${t("employee")} ${year}`,
            });
            total += productivityValue;
            count++;
          }
        });

        const avg = count ? total / count : 0;
        if (avg > 0) {
          months.forEach((month) => {
            line.push({
              year: String(year),
              month: t(month),
              value: Math.round(avg),
              type: `Promedio ${year}`,
            });
          });
        }
      });

      return { consumptionData: cData, lineData: line };
    }, [resultsProductions, baseline, lastThreeYears, months, resultsWorkers, t]);
    const CustomLegend = () => (
      <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px", marginBottom: "20px", paddingLeft: "5px", flexWrap: "wrap" }}>
        {lastThreeYears.map((year) => {
          const isActive = activeYears.includes(year);
          return (
            <div
              key={year}
              onClick={() => toggleYear(year)}
              style={{
                backgroundColor: isActive ? yearColorMap[year] : "#f3f4f6",
                color: isActive ? "white" : "#9ca3af",
                padding: "4px 20px",
                borderRadius: "20px",
                fontSize: "13px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border: isActive ? `1px solid ${yearColorMap[year]}` : "1px solid #d1d5db",
                boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
                userSelect: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "100px",
              }}
            >
              {year}
            </div>
          );
        })}
      </div>
    );

    const [activeYears, setActiveYears] = useState(lastThreeYears);

    const toggleYear = (year) => {
      if (activeYears.includes(year)) {
        setActiveYears(activeYears.filter(y => y !== year));
      } else {
        setActiveYears([...activeYears, year]);
      }
    };

    const filteredConsumptionData = useMemo(() =>
      consumptionData.filter(d => activeYears.includes(String(d.year))),
    [consumptionData, activeYears]);

    const filteredLineData = useMemo(() =>
      lineData.filter(d => activeYears.includes(String(d.year))),
    [lineData, activeYears]);

    const getCssVar = (name) =>
      getComputedStyle(document.documentElement).getPropertyValue(name).trim();

    const chartColors = {
      oldest: getCssVar("--chart-year-oldest"),
      prev: getCssVar("--chart-year-prev"),
      last: getCssVar("--chart-year-last"),
    };

    const yearColorMap = useMemo(() => {
      const sorted = [...lastThreeYears].map(Number).sort((a, b) => a - b);
      return {
        [sorted[0]]: chartColors.oldest || "#cbd5e1",
        [sorted[1]]: chartColors.prev || "#94a3b8",
        [sorted[2]]: chartColors.last || "#1e293b",
      };
    }, [lastThreeYears]);

    const config = {
      xField: "month",
      legend: false,
      scale: {
        color: {
          domain: Object.keys(yearColorMap),
          range: Object.values(yearColorMap),
        },
      },
      tooltip: {
        items: [
          (item) => {
            const marker = item.type?.includes("Promedio") ? "- -" : "";
            return {
              name: `${marker} ${item.type}`.trim(),
              value: item.value,
            };
          },
        ],
      },
      axis: {
        x: { title: false, labelAutoHide: false, labelAutoRotate: false },
        y: { title: false, grid: true },
      },
      children: [
        {
          data: filteredConsumptionData,
          type: "line",
          yField: "value",
          colorField: "year",
          style: { lineWidth: 4 },
          interaction: { elementHighlight: { background: true } },
        },
        {
          data: filteredLineData,
          type: "line",
          yField: "value",
          colorField: "year",
          style: { lineWidth: 2, lineDash: [4, 8] },
          axis: { y: false },
        },
      ],
    };

    return (
      <div style={{ marginTop: 20, marginBottom: 40 }}>
        {consumptionData.length > 0 && <CustomLegend />}
        {consumptionData.length ? (
          <div style={{ height: 350 }}>
            <DualAxes {...config} />
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 350, color: "#999" }}>
            No hay datos disponibles
          </div>
        )}
      </div>
    );
  }

  // Componente para mostrar valores intermedios utilizados en los cálculos
  function IntermediateValuesDisplay({ resultsByYear, resultsWorkers, resultsProductions, t }) {
    const [isOpen, setIsOpen] = useState(false);

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Obtener todos los años disponibles y ordenarlos de mayor a menor
    const availableYears = Object.keys(resultsByYear || {}).sort(
      (a, b) => b - a
    );

    // Limitar a los últimos 5 años
    const lastFiveYears = availableYears.slice(0, 5);

    return (
      <div
        style={{
          margin: "20px 0",
          padding: "15px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          border: "1px solid #dee2e6",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            padding: "10px 0",
          }}
          onClick={() => setIsOpen(!isOpen)}
        >
          <h4 style={{ margin: 0, color: "#495057" }}>
            <Icon name={isOpen ? "chevron down" : "chevron right"} />
            Valores intermedios para verificación de cálculos - Últimos 5 años
          </h4>
          <span style={{ fontSize: "0.9em", color: "#6c757d" }}>
            {isOpen ? "Haz clic para ocultar" : "Haz clic para ver detalles"}
          </span>
        </div>

        {isOpen && (
          <>
            {lastFiveYears.map((year) => (
              <div key={year} style={{ marginBottom: "30px" }}>
                <h5
                  style={{
                    marginTop: "20px",
                    marginBottom: "10px",
                    color: "#495057",
                  }}
                >
                  Año {year}
                </h5>
                <Table celled size="small" style={{ fontSize: "0.9em" }}>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell textAlign="center">Mes</Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        Producción (VPS/VFS)
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        Trabajadores
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {months.map((month) => {
                      const workers = resultsWorkers?.[year]?.[month] || 0;
                      const production = resultsProductions?.[year]?.[month] || 0;

                      return (
                        <Table.Row key={month}>
                          <Table.Cell textAlign="center">
                            {t ? t(month) : month}
                          </Table.Cell>
                          <Table.Cell textAlign="center">
                            {production > 0 ? production.toFixed(2) : "-"}
                          </Table.Cell>
                          <Table.Cell textAlign="center">
                            {workers > 0 ? Math.round(workers) : "-"}
                          </Table.Cell>
                        </Table.Row>
                      );
                    })}
                    <Table.Row
                      style={{ fontWeight: "bold", backgroundColor: "#e9ecef" }}
                    >
                      <Table.Cell textAlign="center">Total</Table.Cell>
                      <Table.Cell textAlign="center">
                        {(() => {
                          const total = months.reduce((sum, month) => sum + (resultsProductions?.[year]?.[month] || 0), 0);
                          return total > 0 ? total.toFixed(2) : "-";
                        })()}
                      </Table.Cell>
                      <Table.Cell textAlign="center">
                        {Math.round(months.reduce((sum, month) => {
                          return sum + (resultsWorkers?.[year]?.[month] || 0);
                        }, 0))}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row
                      style={{ fontWeight: "bold", backgroundColor: "#d1ecf1", color: "#0c5460" }}
                    >
                      <Table.Cell textAlign="center">Promedio</Table.Cell>
                      <Table.Cell textAlign="center">
                        {(() => {
                          const values = months.map((m) => resultsProductions?.[year]?.[m] || 0).filter((v) => v > 0);
                          const avg = values.length > 0 ? values.reduce((a, b) => a + b, 0) / values.length : 0;
                          return avg > 0 ? avg.toFixed(2) : "-";
                        })()}
                      </Table.Cell>
                      <Table.Cell textAlign="center">
                        {(() => {
                          const values = Object.values(resultsWorkers?.[year] || {});
                          const count = values.filter((v) => v > 0).length;
                          const avg = count > 0 ? values.reduce((a, b) => a + b, 0) / count : 0;
                          return Math.round(avg);
                        })()}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </div>
            ))}

            <div
              style={{
                fontSize: "0.85em",
                color: "#6c757d",
                marginTop: "10px",
                textAlign: "center",
              }}
            >
              <strong>Nota:</strong> Estos valores se utilizan como denominadores
              en los cálculos de intensidad. Producción (VPS/VFS) para intensidad
              industrial y Trabajadores para intensidad doméstica.
            </div>
          </>
        )}
      </div>
    );
  }
